import {Link, useNavigate} from "react-router-dom";
import {useEnsureTickersLoaded} from "../../../hooks/useEnsureTickersLoaded";
import {Col, Image, Row, Space, Tooltip, Typography} from "antd";
import Button from "@mui/material/Button";
import {EventOutlined} from "@mui/icons-material";
import {StepForwardOutlined} from "@ant-design/icons";
import React from "react";
import {contentConfig, ContentTitle, BORDER_COLOR, FONT_COLOR} from "./Extra";

const EventAvatar = ({ ticker }) => {
  return (
    <Image
      shape={'square'}
      src={`https://eodhistoricaldata.com${ticker?.logo}`}
      height={32} // Ensure consistent height
      width={32} // Set width to match height to keep a square shape
      style={{ borderRadius: '4px', objectFit: 'contain', display: 'block' }} // Ensure consistent sizing and use objectFit
    />
  );
};


const UpcomingEventsCard = ({ events, uniqueSymbols }) => {
  const navigate = useNavigate();
  const maxVisibleEvents = 5; // Maximum number of visible events
  const currentDate = new Date(); // Get the current date
  const { tickers } = useEnsureTickersLoaded(uniqueSymbols);

  // Filter events to only include those that are on or after the current date
  const upcomingEvents = events.filter(event => new Date(event.start) >= currentDate);

  const filteredEventsWithLogos = upcomingEvents.filter(event => {
    const ticker = tickers.find(x=>x.symbol===event.symbol);
    if (!ticker) return false;
    return ticker.hasOwnProperty('logo') && ticker.logo !== null && ticker.logo?.length > 0;
  });

  // Function to render an event
  const renderEvent = (event, index) => {
    const formattedDate = new Date(event.start).toLocaleDateString('en-US', { weekday: 'long' });
    const formattedEvent = event.type.split('upcoming')[1]?.toUpperCase() || ''; // Handle potential undefined
    return (
      <Row key={index} justify="space-between" align="middle"
           className={'hover-darken round-1'} style={{ padding: '10px 16px', border: `1px solid ${BORDER_COLOR}`, borderRadius: '6px' }}>
          <Col>
              <Row justify={'start'} align={'middle'} gutter={8}>
                  <Col>
                      <EventAvatar ticker={tickers.find(x=>x.symbol===event.symbol)} />
                  </Col>
                  <Col>
                      <Typography.Text className={'mx-4'} style={{
                          textTransform: 'capitalize',
                          color: FONT_COLOR,
                          fontSize: '0.8rem'
                      }}>
                        {formattedDate}
                        <Link to={`/ticker/${event.symbol}`} style={{padding: '0 8px'}}>
                          {event.symbol.toUpperCase()}
                        </Link>
                          {event.shortDesc}
                      </Typography.Text>
                  </Col>
              </Row>

          </Col>

        <Col>
          <Button sx={{ fontWeight: 400 }} endIcon={<EventOutlined />}>
            View
          </Button>
        </Col>
      </Row>
    );
  }

  return (
      <div style={{...contentConfig.style, padding: '1.25% 1.25% 1.25% 0'}} className={'round-2 my-3'}>
        <ContentTitle title={'Upcoming Events'}/>
        <div>
          <Space direction="vertical" style={{ width: '100%' }}>
            {filteredEventsWithLogos.slice(0, maxVisibleEvents).map((event, index) => renderEvent(event, index))}
            {upcomingEvents.length > maxVisibleEvents && (
              <Row justify="center" align="middle" style={{ padding: '10px' }} className={'cursor'} onClick={()=>navigate('/calendar')}>
                <Typography.Text>
                  + {upcomingEvents.length - maxVisibleEvents} more events
                </Typography.Text>
              </Row>
            )}
          </Space>
        </div>
      </div>
  );
};


export default UpcomingEventsCard;